// src/services/projects.ts
import axios from '../axiosInstance';

import type { StatusReportData } from '../types/renders';

export const getAutoRenderJobs = async (): Promise<StatusReportData> => {
  const { data } = await axios.get<StatusReportData>(`/rendering`);
  return data;
};

export const redoFailedRenderTasks = async (projectId: string): Promise<void> => {
  await axios.post(`/rendering/redo-failed-tasks/${projectId}`);
};

